/**
 * detect IE
 * returns version of IE or false, if browser is not Internet Explorer
 * from: https://codepen.io/gapcode/pen/vEJNZN?editors=0010
 */
export const detectIE = function () {
  var ua = window.navigator.userAgent

  // Test values; Uncomment to check result …

  // IE 10
  // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

  // IE 11
  // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

  // Edge 12 (Spartan)
  // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

  // Edge 13
  // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

  var msie = ua.indexOf('MSIE ')
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10)
  }

  var trident = ua.indexOf('Trident/')
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:')
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
  }

  var edge = ua.indexOf('Edge/')
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10)
  }

  // other browser
  return false
}

/**
 * detect iOS
 * returns an object with details of iOS  version
 * or false, if system is not iOS
 * from: https://github.com/bendrucker/ios-version/blob/master/index.js
 */
export const detectiOS = function () {
  var agent = window.navigator.userAgent
  var REGEX = /OS (\d\d?_\d(_\d)?)/

  if (!agent) return false

  var matches = REGEX.exec(agent)
  if (!matches) return false

  var parts = matches[1].split('_').map(d => parseInt(d))

  return {
    major: parts[0],
    minor: parts[1],
    patch: parts[2] || 0
  }
}

/**
 * isSupported
 * returns false if browser is IE or iOS is under 10.3
 * otherwise returns true
 */
export const isSupported = function () {
  let supported = true
  let IE = detectIE()
  let iOS = detectiOS()
  if (IE !== false) {
    supported = false
  }
  if (iOS !== false) {
    const { major, minor } = iOS
    if (major < 10 || (major === 10 && minor < 3)) {
      supported = false
    }
  }
  return supported
}

export default {
  detectIE,
  detectiOS,
  isSupported
}
